import { useCustomAlert } from "../alerts";
import useFetchAndTrace from "../fetchWithTrace";
import { useCallback, useState } from "react";
import settings from "../../../constants/settings";
import useFootprintForPart from "./forPart";

export default function useAddFootprintPartAssociation(
  partId: string,
  onAdd: () => void,
) {
  const { refreshFootprint } = useFootprintForPart(partId);

  const customAlert = useCustomAlert();
  const fetchAndTrace = useFetchAndTrace();
  const [adding, setAdding] = useState(false);

  const errorHandler = useCallback(() => {
    setAdding(false);
    customAlert("Failed to add association");
  }, [customAlert]);

  const searchHandler = useCallback(
    (response: Response) => {
      setAdding(false);
      if (response.ok) {
        refreshFootprint();
        onAdd();
      } else {
        throw Error("Failed to add association");
      }
    },
    [onAdd, refreshFootprint],
  );

  const addFootprintPartAssociation = useCallback(
    (footprintId: string, partId: string) => {
      setAdding(true);
      void fetchAndTrace(
        `${settings.api_url}/footprints/${footprintId}/part-association`,
        searchHandler,
        errorHandler,
        {
          body: JSON.stringify({
            part_id: partId,
          }),
          method: "PUT",
        },
      );
    },
    [errorHandler, fetchAndTrace, searchHandler],
  );

  return {
    adding,
    addFootprintPartAssociation,
  };
}
